export const namespaced = true;

export const state = {
    manageElement: null, //'barrier', //null, //plot, stely
    step: 1,
    showPanelElements: false
}

export const mutations = {
    SET_MANAGE_ELEMENT(state, manageElement) {
        state.manageElement = manageElement;
    },
    SET_STEP(state, step) {
        state.step = step;
    },

    SET_SHOW_PANEL_ELEMENTS(state, showPanelElements) {
        state.showPanelElements = showPanelElements;
    },
}

export const actions = {

    async setManageElement({ commit, dispatch }, manageElement) {
        commit('SET_MANAGE_ELEMENT', manageElement);
        if (manageElement && manageElement !== 'plot' && manageElement !== 'landscaping' && manageElement !== 'barrier') {
            dispatch("clientElements/fetch", manageElement, { root: true });
            dispatch(
                "clientAdditionalWorks/fetch",
                `polish.${manageElement}`, { root: true }
            );
            dispatch("clientAdditionalWorks/fetch", "service", { root: true });
        }
    },

    async setStep({ commit }, step) {
        commit('SET_STEP', step);
    },

    async setShowPanelElements({ commit }, showPanelElements) {
        commit('SET_SHOW_PANEL_ELEMENTS', showPanelElements);
    },

}
